import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import Url from 'url-parse'
import Youtube from 'react-youtube'

const Iframe = styled(Youtube)`
	width: 100%;
	height: 70vh;
`

function getVideoId(url) {
	const parsed = new Url(url, true)
	return parsed.query.v
}

function YoutubePlayer({className, youtubeUrl}) {
	const [iframe, setIframe] = useState(null)
	useEffect(() => () => iframe && iframe.pauseVideo(), [])

	return <Iframe
		className={className}
		id='ytplayer'
		type='text/html'
		onReady={(e) => {
			e.target.playVideo()
			setIframe(e.target)
		}}
		videoId={getVideoId(youtubeUrl)}
	/>
}

YoutubePlayer.propTypes = {
	className: PropTypes.string,
	youtubeUrl: PropTypes.string.isRequired,
}

YoutubePlayer.defaultProps = {
	className: '',
}

export default YoutubePlayer
